import CommonService from "./common.service";
import superAdminApi from "./superAdminApi";

const isLogisticsManagerPortal = () =>
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/dashboard/logistics-manager");

const isSuperAdminPortal = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/super-admin");

export const extractApiMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

function managerBase(path) {
  return `/logistics-manager/exhibition-logistics-rfqs${path}`;
}

function superAdminBase(path) {
  return `/super-admin/logistics/exhibition-logistics-rfqs${path}`;
}

export async function fetchEligibleExhibitionLogisticsProviders(params = {}) {
  const query = {
    search: params.search || params.q || undefined,
    page: params.page,
    pageSize: params.pageSize,
    rfqId: params.rfqId,
  };
  if (isLogisticsManagerPortal()) {
    const res = await CommonService.get(managerBase("/eligible-providers"), query, { silent: true });
    return res?.data ?? { providers: [], total: 0, page: 1, pageSize: 20 };
  }
  const res = await superAdminApi.get(superAdminBase("/eligible-providers"), { params: query });
  return res.data?.data ?? { providers: [], total: 0, page: 1, pageSize: 20 };
}

export async function fetchExhibitionLogisticsProviderAssignments(rfqId) {
  if (isLogisticsManagerPortal()) {
    const res = await CommonService.get(
      managerBase(`/${rfqId}/provider-assignments`),
      {},
      { silent: true },
    );
    return res?.data ?? { providers: [] };
  }
  const res = await superAdminApi.get(superAdminBase(`/${rfqId}/provider-assignments`));
  return res.data?.data ?? { providers: [] };
}

export async function syncExhibitionLogisticsProviderAssignments(rfqId, providerCompanyIds) {
  const body = { providerCompanyIds };
  if (isLogisticsManagerPortal()) {
    const res = await CommonService.put(managerBase(`/${rfqId}/provider-assignments`), body);
    return res?.data ?? res;
  }
  const res = await superAdminApi.put(superAdminBase(`/${rfqId}/provider-assignments`), body);
  return res.data?.data ?? res.data;
}

export function canManageExhibitionLogisticsProviderAssignments() {
  return isLogisticsManagerPortal() || isSuperAdminPortal();
}
